import { Loading } from '@/components/loaders';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const SmsTemplateListLoadingState: FC = () => {
  const { t } = useTranslation('campaign');

  return (
    <div className='flex flex-col items-center justify-center gap-3 py-16'>
      <Loading />
      <p className='text-sm text-secondary-600'>{t('smsWorkspace.templates.loadingTemplates')}</p>
    </div>
  );
};
